/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import type { ChatMessageAction, Role } from 'walden-fast/types/chat';

export interface ChatMessageSignature {
  // The arguments accepted by the component
  Args: {
    role: Role;
    size?: 'full' | 'narrow';
    actions?: ChatMessageAction[];
    date?: Date;
    data?: Record<string, string | null | number>[];
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}

export default class ChatMessageComponent extends Component<ChatMessageSignature> {
  get size() {
    return this.args.size || 'narrow';
  }

  get dataColumns() {
    return this.args.data?.length ? Object.keys(this.args.data[0] || {}) : [];
  }
}
